import React, { useState, useContext } from 'react';
import { CategoryContext } from '../../../Contexts/CategoryContext';
import { useTranslation } from "react-i18next";
import instance from '../../../instance/AxiosInstance';
import Breadcrumb from '../../../Components/Breadcrumb/Breadcrumb';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../../../Contexts/UserContext';
import { toast } from 'react-toastify';

export default function InterestForm() {
  const categories = useContext(CategoryContext);
  const [interests, setInterests] = useState([]);
  const { Categories } = categories;
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const pathSegment = location.pathname.split('/').filter((segment) => segment);
  const {User} = useContext(UserContext)
  const userId = User._id
  
  const handleChange = (categoryId) => {
    setInterests((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId] 
    );
  };

  const sortedCategories = Categories.sort((a, b) => {
    const getName = (category) => {
      if (typeof category.categoryName === "object") {
        return category.categoryName[i18n.language]?.toLowerCase() || "";
      } else if (typeof category.categoryName === "string") {
        return category.categoryName.toLowerCase();
      }
      return "";
    };
    return getName(a).localeCompare(getName(b));
  });

 const handleSubmit = async () => {
  const selectedCategoryIds = Categories
    .filter(category => interests.includes(category._id))
    .map(category => category._id); // Use IDs, not names

  try {
    const response = await instance.post('/api/interests', {
      userId,
      interests: selectedCategoryIds,
    });
    toast.success("Intrest succesfully Added")
  } catch (error) {
    console.error('Error saving preferences:', error?.response?.data || error.message);
  }
};


  return (
    <div style={styles.fullPage}>
      <Breadcrumb pathSegments={pathSegment} />
      <div style={styles.container}>
        <h2 style={styles.heading}>{t('Select Your Interests')}</h2>
        <div style={styles.checkboxGroup}>
          {sortedCategories.map((category) => (
            <div className="checkbox-container" key={category._id}>
              <input
                type="checkbox"
                id={`interest-${category._id}`}
                checked={interests.includes(category._id)}
                onChange={() => handleChange(category._id)}
              />
              <label htmlFor={`interest-${category._id}`}>
                {category.categoryName[i18n.language] || category.categoryName['en']}
              </label>
            </div>
          ))}
        </div>
        <button onClick={handleSubmit} style={styles.submitButton}>
          {t('Save Preferences')}
        </button>
      </div>

      <style>{`
        .checkbox-container {
          position: relative;
          display: flex;
          align-items: center;
          margin: 10px 0;
        }

        .checkbox-container input[type="checkbox"] {
          opacity: 0;
          position: absolute;
        }

        .checkbox-container label {
          position: relative;
          padding-left: 30px;
          cursor: pointer;
          user-select: none;
          font-size: 1rem;
          color: #333;
        }

        .checkbox-container label::before {
          content: '';
          position: absolute;
          left: 0;
          top: 2px;
          width: 20px;
          height: 20px;
          border: 2px solid #046BD2;
          border-radius: 4px;
          background-color: #fff;
        }

        .checkbox-container input[type="checkbox"]:checked + label::before {
          background-color: #046BD2;
          transform: scale(1.1);
        }

        .checkbox-container label::after {
          content: '';
          position: absolute;
          left: 5px;
          top: 7px;
          width: 6px;
          height: 12px;
          border: solid #fff;
          border-width: 0 2px 2px 0;
          opacity: 0;
          transform: rotate(45deg);
        }

        .checkbox-container input[type="checkbox"]:checked + label::after {
          opacity: 1;
        }

        @media (min-width: 768px) {
          .page-container {
            padding: 40px 80px;
          }
        }
      `}</style>
    </div>
  );
}

const styles = {
  fullPage: {
    width: '100%',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    minHeight: '100vh',
    boxSizing: 'border-box',
  },
  container: {
    maxWidth: '700px',
    margin: '20px auto',
    padding: '30px',
    backgroundColor: '#fff',
    borderRadius: '10px',
    boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
    fontFamily: 'Arial, sans-serif',
  },
  heading: {
    color: '#046BD2',
    marginBottom: '20px',
    fontSize: '1.8rem',
    textAlign: 'center',
  },
  checkboxGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  submitButton: {
    marginTop: '20px',
    width: '100%',
    padding: '12px',
    backgroundColor: '#046BD2',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    fontSize: '1rem',
    cursor: 'pointer',
  },
};
